module.exports = __webpack_public_path__ + "img/cross-dark.0723d09.svg";